import configuration from '@/taskpane/common/configuration'
import state from '@/taskpane/state/sidebar-state'

export default interface MessageArgs {
  clientType?: string | null
  groupId: string | null
  userId?: string | null
}

export function defaultMessageArgs(): MessageArgs {
  return {
    groupId: configuration.LEGACY_SOCKET_GROUP_ID,
    clientType: configuration.CLIENT_TYPE,
    userId: state.userEmail,
  }
}
